export default __webpack_public_path__ + "static/media/card.c3d4fc11.mp4";